// extracted by mini-css-extract-plugin
module.exports = {"Toast":"Toast_Toast__2_oke","EDocToast":"Toast_EDocToast__2r52U"};